import {
  initCoreFrontApp,
  initCoreFrontAppArgs,
} from '../CORE/src/front/AppInitializer/initCoreFrontApp'
import models from '../models/fireModels'
import { yhcAreaCodes, yhcAreasByCode } from '../models/constants/area'
import { installYhcEstimateFormComponents } from '../models/services/YhcEstimateFormFrontPage/installYhcEstimateFormComponents'
// @ts-ignore
import KickMasterDataImportWithVersionButton from '../models/services/YhcMasterDataGenerator/front/KickMasterDataImportWithVersionButton.vue'
import { openKickMasterDataImportWithVersionModal } from '../models/services/YhcMasterDataGenerator/front/openKickMasterDataImportWithVersionModal'

// @ts-ignore
import YhcEstimateForm from '../models/services/YhcEstimateFormFrontPage/YhcEstimateForm.vue'
import { $yhcGA4EventSender } from '../models/services/YhcEstimateFormFrontPage/YhcGA4EventSender'
import YhcServiceInfoPage from '../models/services/YhcServiceInfoPageFromSms/YhcServiceInfoPage.vue'
import YhcServiceLevel from '../models/services/YhcServiceLevelList/YhcServiceLevel.vue'
import { registerUnconfirmedServiceLevelFeedbackModal } from '../models/services/YhcServiceLevelList/registerUnconfirmedServiceLevelFeedbackModal'
import '../models/fireModels/yhc_service_level_feedbacks.scss'
import {
  registerAdminAppMenuModelListSort,
  registerHideYhcMasterVersionsFromAppMenu,
} from './registerAdminAppMenuModelListSort'

const coreFrontInitArg: initCoreFrontAppArgs = {
  modelDefinitions: models,
  additionalRoutes: [
    {
      // プレビュー用
      path: '/esform-preview',
      name: 'estimate',
      // @ts-ignore
      component: YhcEstimateForm,
      props: {
        isPreviewMode: true,
        autoInit: false,
      },
    },
    {
      // 開発用 form 表示 (管理画面 App からリンクしない)
      path: '/esform-preview-without-config',
      name: 'esform-preview-without-config',
      // @ts-ignore
      component: YhcEstimateForm,
      props: {
        // 開発用に input data を保持
        enableAutoSaveOfUserInputData: true,
      },
    },
    {
      // 開発用 form 表示 (管理画面 App からリンクしない)
      path: '/esform-preview-without-config-nosidebar',
      name: 'esform-preview-without-config-nosidebar',
      // @ts-ignore
      component: YhcEstimateForm,
      props: {
        // 開発用に input data を保持
        enableAutoSaveOfUserInputData: true,
      },
      meta: {
        layout: 'empty',
      },
    },
    {
      // SMS経由のサービス案内ページ
      path: '/service-info-page-from-sms',
      name: 'service-info-page-from-sms',
      component: YhcServiceInfoPage,
    },
    {
      // サービスレベル表　プレビュー用
      path: '/service-level-preview',
      name: 'service-level',
      component: YhcServiceLevel,
      props: {
        isPreviewMode: true,
      },
    },
  ],
}

/**
 * Initialize core
 */
initCoreFrontApp(coreFrontInitArg).then((startAppFunction) => {
  if (!$core.$yhc) {
    $core.$yhc = {}
  }
  $core.$yhc.openKickMasterDataImportWithVersionModal =
    openKickMasterDataImportWithVersionModal
  // globalThis.$core.$router.addRoutes(pageRoutes)
  $core.yhcAreasByCode = yhcAreasByCode
  $core.yhcAreaCodes = yhcAreaCodes
  registerUnconfirmedServiceLevelFeedbackModal()
  registerAdminAppMenuModelListSort()
  registerHideYhcMasterVersionsFromAppMenu()
  installYhcEstimateFormComponents($core.VueClass)
  $core.VueClass.component(
    'KickMasterDataImportWithVersionButton',
    KickMasterDataImportWithVersionButton,
  )
  // GA4へ初期表示時のイベント送信
  $yhcGA4EventSender.initIndexPage()

  startAppFunction() // start app
})
